// frontend/src/screens/ChatScreen.jsx
import React, { useContext, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import ChatWindow from '../components/ChatWindow';
import { localizedValue } from '../localization/presentationLanguage';
const chatText = (es, en) => localizedValue({ es, en });

export default function ChatScreen() {
  const { conversationId } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const me = useMemo(() => ({
    userId: user?._id || user?.id || user?.userId || null,
    fullName: user?.fullName || chatText('Yo', 'Me'),
  }), [user]);

  if (!conversationId) {
    return (
      <div style={{ padding: 12 }}>
        <p>{chatText('Conversación no encontrada.', 'Conversation not found.')}</p>
        <button onClick={() => navigate('/contacts')}>{chatText('Volver a contactos', 'Back to contacts')}</button>
      </div>
    );
  }

  return (
    <div style={{ padding: 12 }}>
      <button onClick={() => navigate(-1)} style={{ marginBottom: 12 }}>
        {chatText('← Volver', '← Back')}
      </button>
      <h2>Chat</h2>
      <ChatWindow conversationId={conversationId} me={me} />
    </div>
  );
}
